import { ButtonInterface } from 'common/types/entities/button-interface'
import React from 'react'
import { ButtonTypeGroup } from 'src/editor/shared/settings/groups/button-type-group'
import { CommonButtonSettings } from '../common-button-settings'

interface RegistrationButtonSettingsProps {
  entity: ButtonInterface
  defaultEntity?: ButtonInterface
}

export const RegistrationButtonSettings = ({
  entity,
  defaultEntity,
}: RegistrationButtonSettingsProps) => {
  return (
    <>
      <ButtonTypeGroup entity={entity} />
      <CommonButtonSettings entity={entity} defaultEntity={defaultEntity} />
    </>
  )
}
